var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trade" }, [
    _c("div", { staticClass: "container-header" }, [
      _c("div", { staticClass: "container-header__title" }, [
        _vm._v(_vm._s(_vm.i18n.lbl_trade()))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "trade-block trade__container" },
      [
        _c("chart", {
          staticClass: "container container_40 trade__chart",
          attrs: {
            data: _vm.history,
            volume: _vm.volume,
            pairs: _vm.formattedPairs,
            precision: _vm.common.precision,
            assets: _vm.customAssetPair
          },
          on: {
            "assets-base-changed": _vm.handleAssetChange,
            "assets-quote-changed": _vm.handleAssetChange
          }
        }),
        _vm._v(" "),
        _c("trade-history", {
          staticClass: "container container_40 trade__history",
          attrs: { assets: _vm.filters }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "trade-block" },
      [
        _c("orders", {
          staticClass: "md-layout-item md-size-100",
          attrs: { assets: _vm.filters }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "trade-block" },
      [
        _c("trade-orders", {
          staticClass: "md-layout-item md-size-100",
          attrs: { assets: _vm.filters }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "trade-block" },
      [
        _c("manage-orders", {
          staticClass: "md-layout-item md-size-100",
          attrs: { assets: _vm.filters, offers: _vm.userOffers }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfaa4cc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfaa4cc0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/Trade.Index.vue
// module id = 7Kvl
// module chunks = 1